import React, { useEffect, useState } from 'react'
import { supabase } from '../../lib/supabaseClient'

type Partner = {
  id: string
  name: string
}

type PartnerSelectProps = {
  value: string | null
  onChange: (partnerId: string | null) => void
  style?: React.CSSProperties
}

const PartnerSelect: React.FC<PartnerSelectProps> = ({ value, onChange, style }) => {
  const [partners, setPartners] = useState<Partner[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const load = async () => {
      setLoading(true)
      const { data, error } = await supabase
        .from('partners')
        .select('id, name')
        .order('name')

      if (!error && data) setPartners(data)
      setLoading(false)
    }
    void load()
  }, [])

  return (
    <select
      data-testid="partner-select"
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value || null)}
      disabled={loading}
      style={{
        width: '100%',
        maxWidth: '400px',
        padding: '0.5rem 0.75rem',
        border: '1px solid #cbd5e1',
        borderRadius: '0.375rem',
        fontSize: '0.9rem',
        background: 'white',
        boxSizing: 'border-box',
        ...style,
      }}
    >
      <option value="">
        {loading ? 'Chargement…' : '— Sélectionner un partenaire —'}
      </option>
      {partners.map((p) => (
        <option key={p.id} value={p.id}>
          {p.name}
        </option>
      ))}
    </select>
  )
}

export default PartnerSelect
